import { Capacitor } from '@capacitor/core'
import { useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'
import { Log } from '~/shared/api'
import { notificationModalOpen } from '~/shared/lib/notificationModal'

export const useTinkoffPayError = () => {
  const driverId = useStoreMap(
    driverModel.$driver,
    (profile) => profile?.getApiId() as UniqueId,
  )

  const tinkoffPayError = (message: string | null | undefined) => {
    const platform = Capacitor.getPlatform()
    const title = 'Пополнение баланса не удалось из-за ошибки на стороне банка'
    const description =
      message ||
      'К сожалению, возникла ошибка при попытке пополнения баланса. Пожалуйста, попробуйте еще раз позже.'

    notificationModalOpen({
      title,
      description,
      variant: 'error' as const,
    })

    Log.sendMessage({
      driverId,
      platform,
      title,
      message: description,
    })
  }

  return { tinkoffPayError }
}
